import { useSelector } from "react-redux";

// Access levels
export const ACCESS_LEVELS = {
    NO_ACCESS: 0,
    READ_ONLY: 1,
    READ_WRITE: 2,
};

// Feature keys matching backend model (using dot notation for nested paths)
export const FEATURES = {
    // Dashboard
    DASHBOARD: "dashboard",
    DASHBOARD_USER_CHART: "dashboard.userChart",
    DASHBOARD_TOTAL_USER: "dashboard.totalUser",
    DASHBOARD_TOTAL_LIVE_USER: "dashboard.totalLiveUser",
    DASHBOARD_TOTAL_ACTIVE_USER: "dashboard.totalActiveUser",
    DASHBOARD_TOTAL_VIP_USER: "dashboard.totalVipUser",
    DASHBOARD_TOTAL_REVENUE: "dashboard.totalRevenue",
    DASHBOARD_TOTAL_POST: "dashboard.totalPost",
    DASHBOARD_TOTAL_VIDEO: "dashboard.totalVideo",
    DASHBOARD_TOTAL_REPORTED_USER: "dashboard.totalReportedUser",
    DASHBOARD_TOTAL_USER_DIAMOND: "dashboard.totalUserDiamond",
    DASHBOARD_TOTAL_USER_VCOIN: "dashboard.totalUserVCoin",

    // Users
    USERS: "users.users",
    BANNED_USERS: "users.bannedUsers",
    BANNED_DEVICES: "users.bannedDevices",
    WHITELISTED_DEVICES: "users.whiteListedDevices",

    // Live
    PARTY_ROOM: "live.partyRoom",
    VIDEO_LIVE: "live.videoLive",
    LIVE_BANNED_USERS: "live.bannedUsers",

    // Banner & Party Challenge (top-level)
    BANNER: "banner",
    PARTY_CHALLENGE: "partyChallenge",

    // Plan
    DIAMOND_PLAN: "plan.diamondPlan",
    VIP_PLAN: "plan.vipPlan",

    // Plan History
    DIAMOND_PLAN_HISTORY: "planHistory.diamondPlan",
    VIP_PLAN_HISTORY: "planHistory.vipPlan",
    PURCHASE_TRANSACTIONS: "planHistory.purchaseTransactions",

    // Game History
    GAME_TEEN_PATTI: "gameHistory.teenPatti",
    GAME_TEEN_PATTI_SUMMARY_TOTAL_GAMES: "gameHistory.teenPatti.summaryCards.totalGames",
    GAME_TEEN_PATTI_SUMMARY_DIAMOND_SPENT: "gameHistory.teenPatti.summaryCards.totalDiamondSpent",
    GAME_TEEN_PATTI_SUMMARY_DIAMONDS_WON: "gameHistory.teenPatti.summaryCards.totalDiamondsWon",
    GAME_TEEN_PATTI_SUMMARY_HOUSE_PROFIT: "gameHistory.teenPatti.summaryCards.houseProfit",
    GAME_TEEN_PATTI_ADMIN_DIAMONDS: "gameHistory.teenPatti.adminDiamonds",
    GAME_VIBE_WHEEL: "gameHistory.vibeWheel",
    GAME_VIBE_WHEEL_SUMMARY_TOTAL_GAMES: "gameHistory.vibeWheel.summaryCards.totalGames",
    GAME_VIBE_WHEEL_SUMMARY_DIAMOND_SPENT: "gameHistory.vibeWheel.summaryCards.totalDiamondSpent",
    GAME_VIBE_WHEEL_SUMMARY_DIAMONDS_WON: "gameHistory.vibeWheel.summaryCards.totalDiamondsWon",
    GAME_VIBE_WHEEL_SUMMARY_HOUSE_PROFIT: "gameHistory.vibeWheel.summaryCards.houseProfit",
    GAME_VIBE_WHEEL_ADMIN_DIAMONDS: "gameHistory.vibeWheel.adminDiamonds",
    GAME_DIAMOND_RAIN: "gameHistory.diamondRain",
    GAME_DIAMOND_RAIN_SUMMARY_TOTAL_GAMES: "gameHistory.diamondRain.summaryCards.totalGames",
    GAME_DIAMOND_RAIN_SUMMARY_DIAMOND_SPENT: "gameHistory.diamondRain.summaryCards.totalDiamondSpent",
    GAME_DIAMOND_RAIN_SUMMARY_DIAMONDS_WON: "gameHistory.diamondRain.summaryCards.totalDiamondsWon",
    GAME_DIAMOND_RAIN_SUMMARY_DIAMONDS_REFUNDED: "gameHistory.diamondRain.summaryCards.totalDiamondsRefunded",
    GAME_BAISHUN: "gameHistory.baishun",
    GAME_BAISHUN_SUMMARY_TOTAL_GAMES: "gameHistory.baishun.summaryCards.totalGames",
    GAME_BAISHUN_SUMMARY_DIAMOND_SPENT: "gameHistory.baishun.summaryCards.totalDiamondSpent",
    GAME_BAISHUN_SUMMARY_DIAMONDS_WON: "gameHistory.baishun.summaryCards.totalDiamondsWon",
    GAME_BAISHUN_SUMMARY_HOUSE_PROFIT: "gameHistory.baishun.summaryCards.houseProfit",

    // Gift
    GIFT_CATEGORIES: "gift.categories",
    ALL_GIFTS: "gift.allGifts",

    // Store
    ENTRANCE_EFFECTS: "store.entranceEffects",
    AVATAR_FRAME: "store.avatarFrame",
    BACKGROUND: "store.background",
    DIAMOND_SHOP: "store.diamondShop",

    // Rewards
    SEND_REWARD: "rewards.sendReward",
    LEVEL_UP_REWARDS: "rewards.levelUpRewards",
    RECHARGE_REWARDS: "rewards.rechargeRewards",
    VIP_REWARDS: "rewards.vipRewards",
    DAILY_TASK_REWARDS: "rewards.dailyTaskRewards",

    // Top-level features
    STICKER: "sticker",
    THEME: "theme",
    AR_EFFECTS: "arEffects",
    SONG: "song",
    HASHTAG: "hashtag",
    LEVEL: "level",
    POST: "post",
    REELS: "reels",

    // Diamond Seller
    DIAMOND_SELLERS: "diamondSeller.diamondSellers",
    DIAMOND_SELLER_SHOP: "diamondSeller.diamondSellerShop",

    // Reports
    REPORTED_USERS: "reports.reportedUsers",
    REPORTED_MOMENTS: "reports.reportedMoments",
    REPORTED_REELS: "reports.reportedReels",

    // Complain
    COMPLAIN_PENDING: "complain.pending",
    COMPLAIN_RESOLVED: "complain.resolved",

    // Redeem
    REDEEM_PENDING: "redeem.pending",
    REDEEM_ACCEPTED: "redeem.accepted",
    REDEEM_DECLINED: "redeem.declined",
    REDEEM_PAYMENT_METHODS: "redeem.paymentMethods",

    // Other top-level
    DEACTIVATION: "deactivation",
    GOOGLE_AD: "googleAd",
    SETTINGS: "settings",

    // Backend Management
    BACKEND_MAKE_VIP: "backendManagement.makeVip",
    BACKEND_DIAS_APP_PURCHASE: "backendManagement.diasAppPurchase",
    BACKEND_GHOST_ACCOUNTS: "backendManagement.ghostAccounts",
    BACKEND_RESTRICTED_ACCOUNTS: "backendManagement.restrictedAccounts",
    BACKEND_GAME_SETTINGS: "backendManagement.gameSettings",
    BACKEND_REOPEN_TREASURE_BOX: "backendManagement.reopenTreasureBox",
    BACKEND_IP_MANAGEMENT: "backendManagement.ipManagement",
    BACKEND_SUSPICIOUS_GIFT_PAIRS: "backendManagement.suspiciousGiftPairs",
    BACKEND_FACE_REVIEWS: "backendManagement.faceReviews",

    // Admin Management
    ADMIN_MANAGEMENT: "adminManagement",
};

/**
 * Helper function to get nested value from object using dot notation
 * @param {Object} obj - The object to traverse
 * @param {string} path - Dot-separated path (e.g., "dashboard.userChart")
 * @returns {*} The value at the path or undefined
 */
const getNestedValue = (obj, path) => {
    if (!obj || !path) return undefined;
    const keys = path.split(".");
    let current = obj;
    for (const key of keys) {
        if (current === undefined || current === null) return undefined;
        current = current[key];
    }
    return current;
};

/**
 * Hook to check if admin has access to a feature
 * @returns {Object} Access check functions
 */
export const useAccess = () => {
    const adminAccess = useSelector((state) => state.adminAccess.adminAccess);
    const admin = useSelector((state) => state.admin.admin);

    // Check if admin is a SuperAdmin (flag: true)
    const isSuperAdmin = admin?.flag === true;

    /**
     * Get access level for a feature using dot notation path
     * Based purely on the adminAccess feature values
     * @param {string} featurePath - Feature path (e.g., "dashboard.userChart" or "banner")
     * @returns {number} Access level (0, 1, or 2)
     */
    const getAccessLevel = (featurePath) => {
        if (!adminAccess || !featurePath) {
            console.log("No adminAccess or featurePath");
            return ACCESS_LEVELS.NO_ACCESS;
        }

        const value = getNestedValue(adminAccess, featurePath);

        // If the value is an object (nested category), check if any child has access
        if (typeof value === "object" && value !== null) {
            // For parent categories, grant access if any child feature has access
            const hasAnyAccess = Object.values(value).some((v) => {
                if (typeof v === "object" && v !== null) {
                    // Handle deeply nested objects (like gameHistory.teenPatti.summaryCards)
                    return Object.values(v).some((vv) =>
                        typeof vv === "number" ? vv >= ACCESS_LEVELS.READ_ONLY : false
                    );
                }
                return typeof v === "number" && v >= ACCESS_LEVELS.READ_ONLY;
            });
            return hasAnyAccess ? ACCESS_LEVELS.READ_ONLY : ACCESS_LEVELS.NO_ACCESS;
        }

        return typeof value === "number" ? value : ACCESS_LEVELS.NO_ACCESS;
    };

    /**
     * Check if admin has at least read access (based purely on feature values)
     * @param {string} featurePath - Feature path from FEATURES
     * @returns {boolean}
     */
    const canView = (featurePath) => {
        return getAccessLevel(featurePath) >= ACCESS_LEVELS.READ_ONLY;
    };

    /**
     * Check if admin has write access (based purely on feature values)
     * @param {string} featurePath - Feature path from FEATURES
     * @returns {boolean}
     */
    const canEdit = (featurePath) => {
        return getAccessLevel(featurePath) >= ACCESS_LEVELS.READ_WRITE;
    };

    /**
     * Check if admin has no access (based purely on feature values)
     * @param {string} featurePath - Feature path from FEATURES
     * @returns {boolean}
     */
    const hasNoAccess = (featurePath) => {
        return getAccessLevel(featurePath) === ACCESS_LEVELS.NO_ACCESS;
    };

    /**
     * Check if current admin is a SuperAdmin
     * Use this for role-based checks separate from feature access
     * @returns {boolean}
     */
    const checkIsSuperAdmin = () => {
        return isSuperAdmin;
    };

    /**
     * Get admin's role from adminAccess
     * @returns {string|null} Role ("Admin", "SuperAdmin", "Viewer") or null
     */
    const getRole = () => {
        return adminAccess?.role || null;
    };

    /**
     * Get current admin ID
     * @returns {string|null} Admin ID or null
     */
    const getCurrentAdminId = () => {
        return admin?._id || null;
    };

    return {
        isSuperAdmin,
        getAccessLevel,
        canView,
        canEdit,
        hasNoAccess,
        checkIsSuperAdmin,
        getRole,
        getCurrentAdminId,
    };
};

export default useAccess;
